import { fetchApi } from "containers/helpers";

export const getMissions = () => fetchApi('/admin/missions')